<template>
  <div v-loading="loading" class="row d-flex justify-content-center">
    <div class="col-md-12">
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group row">
            <label for="purchase_csv" class="col-md-3 col-form-label">Purchase Summary CSV</label>
            <div class="col-md-9">
              <el-upload
                ref="purchase_csv"
                action
                :file-list="fileListPurchaseCsv"
                :on-change="handleUploadPurchaseCsv"
                :multiple="false"
                :auto-upload="false"
                >
                  <el-button size="small" type="primary">Select Purchase CSV</el-button>
              </el-upload>
            </div>
          </div>

          <div class="form-group row">
            <label for="invoice" class="col-md-3 col-form-label">Invoice</label>
            <div class="col-md-9">
              <el-upload
                ref="invoice"
                action
                :file-list="fileListInvoice"
                :on-change="handleUploadInvoice"
                :multiple="false"
                :auto-upload="false"
                >
                  <el-button size="small" type="primary">Select Invoice</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group row">
            <label for="value" class="col-md-3 col-form-label"></label>
            <label for="value" class="col-md-4 col-form-label">GST Inclusive</label>
            <label for="value" class="col-md-4 col-form-label">GST Exclusive</label>
          </div>
          <div class="form-group row">
            <label for="total_invoice_value" class="col-md-4 col-form-label">Total Invoice Value</label>
            <div class="col-md-4">
              <currency-input
                id="total_invoice_value"
                class="form-control"
                v-model="purchase.dollar_value"
              />
            </div>
            <div class="col-md-4">
              <currency-input
                class="form-control"
                v-model="dollarValueExGST"
                disabled
              />
            </div>
          </div>

          <div class="form-group row">
            <label for="averagePrice" class="col-md-3 col-form-label">Avg $/kg</label>
            <div class="col-md-4">
              <currency-input
                id="averagePrice"
                class="form-control"
                v-model="averagePricePerKilo"
                disabled
              />
            </div>
            <div class="col-md-4">
              <currency-input 
                class="form-control"
                v-model="averagePricePerKiloExGST"
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group row">
            <label for="date_of_sale" class="col-md-3 col-form-label">Invoice Date</label>
            <div class="col-md-4">
              <el-date-picker
                class="w-100"
                v-model="purchase.date_of_sale"
                value-format="yyyy-MM-dd 00:00:00"
                format="dd/MM/yyyy"
                type="date"
                placeholder="Pick a day"
              ></el-date-picker>
            </div>
          </div>

          <div class="form-group row">
            <label for="seller_name" class="col-md-3 col-form-label">Seller Name</label>
            <div class="col-md-4">
              <input
                type="text"
                class="form-control"
                aria-describedby="seller_name"
                v-model="purchase.seller_name"
              />
            </div>
          </div>

          <div class="form-group row">
            <label for="term" class="col-md-3 col-form-label">Term</label>
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                aria-describedby="seller_name"
                v-model="purchase.term"
              />
            </div>
          </div>

          <div class="form-group row">
            <label for="number_of_head" class="col-md-3 col-form-label">No Of Head</label>
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                aria-describedby="seller_name"
                v-model="purchase.number_of_head"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="number_of_head" class="col-md-3 col-form-label">Average Weight</label>
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                aria-describedby="seller_name"
                v-model="purchase.average_weight" 
              />
            </div>
          </div>
          </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group row">
            <label for="livestock_class_id" class="col-md-3 col-form-label">Livestock Class</label>
            <el-select
              class="col-md-4"
              clearable
              v-model="purchase.livestock_class_id"
              @change="purchase.breed_category_id = '';purchase.sex_id = ''"
              placeholder="Select"
            >
              <el-option
                v-for="item in livestock_classes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <div class="form-group row">
            <label for="breed_category_id" class="col-md-3 col-form-label">Breed</label>
            <el-select
              class="col-md-4"
              clearable
              v-model="purchase.breed_category_id"
              placeholder="Select"
            >
              <el-option
                v-for="item in breed_categories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <div class="form-group row">
            <label for="sex_id" class="col-md-3 col-form-label">Sex</label>
            <el-select class="col-md-4" clearable v-model="purchase.sex_id" placeholder="Select">
              <el-option v-for="item in sexes" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>

          <div class="form-group row">
            <label for="hpg_category_id" class="col-md-3 col-form-label">HPG</label>
            <el-select class="col-md-4" clearable v-model="purchase.hpg_category_id" placeholder="Select">
              <el-option v-for="item in hpg_categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>

          <div class="form-group row">
            <label for="end_market_id" class="col-md-3 col-form-label">End Market</label>
            <el-select class="col-md-4" clearable v-model="purchase.end_market_id" placeholder="Select">
              <el-option v-for="item in end_markets" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="form-group row">
            <label for="property_id" class="col-md-3 col-form-label">Destination PIC</label>
            <el-select class="col-md-4" clearable v-model="purchase.property_id" placeholder="Select">
              <el-option v-for="item in business.properties" :key="item.id" :label="item.pic" :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="row">
            <div class="col-12">
              <hr />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 d-flex justify-content-end">
              <el-button type="primary" plain @click="handleSubmit">Submit</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Papa from "papaparse";

export default {
  props: {
    business: {
      type: Object
    },
    livestock_classes: {
      type: Array
    },
    hpg_categories: {
      type: Array
    },
    end_markets: {
      type: Array
    }
  },
  computed: {
    breed_categories() {
      let category = this.livestock_classes.filter(
                      x => x.id == this.purchase.livestock_class_id
                    )[0]; 

      return category && this.purchase.livestock_class_id
            ? category.breed_categories
            : [];
    },
    sexes() {
      let category = this.livestock_classes.filter(
                      x => x.id == this.purchase.livestock_class_id
                    )[0]; 

      return category && this.purchase.livestock_class_id
            ? category.sexes
            : [];
    },
    averagePricePerKilo: {
      get() {
        let value = 0;
        if (this.totalWeight > 0 ) value = Number(this.purchase.dollar_value / this.totalWeight).toFixed(2);
        
        this.purchase.average_dollar_per_kilo = value;
        return value;
      }
    },
    dollarValueExGST: {
      get() {
        return this.purchase.dollar_value /1.1;
      }
    },
    averagePricePerKiloExGST: {
      get() {
        return this.averagePricePerKilo /1.1;
      }
    },
    totalWeight: {
      set(value) {
        this.purchase.weight_total = Number(value);
      },
      get() {
        const total = Number(this.purchase.number_of_head || 0) * Number(this.purchase.average_weight || 0);
        this.purchase.weight_total = total;
        return this.purchase.weight_total;
      }
    }
  },
  data() {
    return {
      //
      purchase: {
        date_of_sale: "",
        value: 0,
        dollar_value: 0,
        seller_name: "",
        weight_total: 0,
        term: "",
        sex_id: "",
        market_category_id: "",
        livestock_category_id: "",
        livestock_class_id: "",
        number_of_head: 0,
        average_weight: 0,
        average_dollar_per_kilo: 0,
        purchase_assets: [],
        breed_category_id: null,
        hpg_category_id: null,
        end_market_id: null,
      },
      fileListPurchaseCsv:[],
      fileListInvoice:[],
      purchase_assets: "",
      loading: false,
      form_data: new FormData()
    };
  },
  methods: {
    handleSubmit() {
      //
      this.loading = true;
      this.form_data.append("date_of_sale", this.purchase.date_of_sale);
      this.form_data.append("value", this.purchase.dollar_value * 100);
      this.form_data.append("seller_name", this.purchase.seller_name);
      this.form_data.append("term", this.purchase.term);
      this.form_data.append("sex_id", this.purchase.sex_id);
      this.form_data.append("hpg_category_id", this.purchase.hpg_category_id);
      this.form_data.append("breed_category_id", this.purchase.breed_category_id);
      this.form_data.append("end_market_id", this.purchase.end_market_id);
      this.form_data.append("property_id", this.purchase.property_id);
      this.form_data.append("number_of_head", this.purchase.number_of_head);
      this.form_data.append(
        "market_category_id",
        this.purchase.market_category_id
      );
      this.form_data.append(
        "livestock_category_id",
        this.purchase.livestock_category_id
      );
      this.form_data.append(
        "livestock_class_id",
        this.purchase.livestock_class_id
      );
      this.form_data.append("average_weight", this.purchase.average_weight);
      this.form_data.append("average_dollar_per_kilo", this.purchase.average_dollar_per_kilo);
      // invoice upload
      if (this.$refs.invoice.fileList.length > 0) this.form_data.append('invoice', this.$refs.invoice.fileList[0].raw);
      if (this.$refs.purchase_csv.fileList.length > 0) this.form_data.append('purchase_csv', this.$refs.purchase_csv.fileList[0].raw);
      axios
        .post(
          `/api/v1/businesses/${this.business.id}/purchases`,
          this.form_data,
          {
            headers: { "content-type": "multipart/form-data" }
          }
        )
        .then(res => {
          this.$message({
            type: "success",
            message: "Successfully added purchase for review"
          });
          this.$emit("onAdd", res.data);
          this.$emit("close");
        })
        .catch(errors => {
          console.log(errors);
          var errorText = "";
          if (errors.response.data.message) {
            errorText += "" + errors.response.data.message + " ";
          }
          _.forEach(errors.response.data.errors, function(value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText
          });
          this.form_data = new FormData();
          this.$refs["purchase_csv"].value = "";
          this.$refs["invoice"].value = "";
          this.loading = false;
        });
    },
    handleUploadPurchaseCsv(file){
      this.fileListPurchaseCsv = [file];
    },
    handleUploadInvoice(file){
      this.fileListInvoice = [file];
    },
  }
};
</script>